import React, { useState, useEffect }  from 'react';
import { useSelector } from 'react-redux';
import { Card, Row, Col, Badge, List, Image, Space, Tooltip, Carousel, Empty } from 'antd';
import moment from 'moment';
import Moment from 'react-moment';

import * as ToolRequest from '../../tools/ToolRequest';
import * as ToolMath from '../../tools/ToolMath';
import * as ToolImage from '../../tools/ToolImage';

import SpinFull from '../../components/SpinFull';

export default function HomeSiteCardStationListItem(props) {
  const { station } = props;
  const zoneIoConfigsData = useSelector(state => state.zoneIoConfigs);

  const [loaded, setLoaded] = useState(false);
  const [status, setStatus] = useState(null);
  const [cameraFiles, setCameraFiles] = useState([]);

  useEffect(() => {
    (async () => {
      const stationAllRes = await ToolRequest.request('GET', `/v1/station/${station.id}/all`);

      // station status
      const stationStatus = await ToolRequest.request('GET', `/v1/station-status`, {
        stationId: station.id,
      });
      setStatus(stationStatus);

      // zones
      const zones = stationAllRes.zones;
      for (let zone of zones) {
        for (let zoneIo of zone.ios) {
          const zoneIoConfig = zoneIoConfigsData.find(zoneIoConfigItem => zoneIoConfigItem.type === zoneIo.type);

          if (!zoneIoConfig || (!zoneIoConfig.inputs && !zoneIoConfig.outputs)) {
            continue;
          }

          zoneIo.config = zoneIoConfig;
        }
      }

      // cameras
      const cameraFilesNew = [];

      const beginAt = moment().subtract(7, 'day');

      for (let zone of zones) {
        for (let zoneIo of zone.ios) {
          if (zoneIo.config.inputs && zoneIo.config.inputs.indexOf('IMAGE_INPUT') > -1) {

            const fileRes = await ToolRequest.request('GET', '/v1/station-file', {
              stationId: station.id,
              zoneIoId: zoneIo.id,
              beginAt: beginAt.toISOString(),
              count: 1,
            });

            if (fileRes.data.length) {
              cameraFilesNew.push({
                file: fileRes.data.length ? fileRes.data[0] : null,
                zoneIo,
              });
            }
          }
        }
      }

      setCameraFiles(cameraFilesNew);
      setLoaded(true);
    })();
  }, []);

  return (
    <List.Item>
      {loaded ? (
        <Row style={{ width: '100%' }} wrap={false}>
          <Col flex="240px">
            <a href={`#/station/dashboard/${station.id}`}>
              <Badge status={status.isSocketConnecting ? 'success' : 'error'} text={station.displayName} />
            </a>
          </Col>
          <Col flex="auto">
            <div className="image-horizontal-container">
              <Space>
                {loaded ? (
                  cameraFiles.some(cameraFile => cameraFile.file) ? (
                    cameraFiles.map((cameraFile, i) => (
                      <div key={i}>
                        <Image
                          src={ToolImage.getImageproxyUrl(cameraFile.file.url, 200)}
                          preview={{
                            src: ToolImage.getImageproxyUrl(cameraFile.file.url, 720),
                          }}
                          width={426}
                        />
                        <div>
                          <Tooltip title={moment(cameraFile.file.capturedAt).format('YYYY-MM-DD HH:mm:ss')}>
                            Captured {moment(cameraFile.file.capturedAt).fromNow()}
                          </Tooltip>
                        </div>
                      </div>
                    ))
                  ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No images" />
                ) : <SpinFull />}
              </Space>
            </div>
          </Col>
        </Row>
      ) : <SpinFull style={{ width: '100%', height: 22 }} />}
    </List.Item>
  );
};
